"use client";

import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "@/app/contact/contact.css";

export default function BlogFaqSection({ faqSection }) {
  const [activeIndex, setActiveIndex] = useState(null);

  if (!faqSection || !faqSection.faqs || faqSection.faqs.length === 0) {
    return null;
  }

  const rawFaqs = faqSection.faqs || [];
  const faqs = rawFaqs.filter(f => f.question && f.answer);

  if (faqs.length === 0) return null;

  const title = faqSection.title || "Got Questions\nWe've Got Answers!";
  
  // Format title to have a newline if it contains "We've Got Answers!" without newline
  let formattedTitle = title;
  if (!title.includes("\n") && title.includes("We've Got Answers!")) {
    formattedTitle = title.replace("We've Got Answers!", "\nWe've Got Answers!");
  }

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="accordion-bg mt-5 pt-4 pb-5">
      <div className="accordion-section mb-5 text-center">
        <h2 
          className="text-white font-extrabold"
          style={{ 
            textTransform: "none", 
            textAlign: "center", 
            fontSize: "2.2rem", 
            fontWeight: "800", 
            color: "#ffffff",
            whiteSpace: "pre-line",
            lineHeight: "1.25"
          }}
        >
          {formattedTitle}
        </h2>
      </div>
      <div className="container" style={{ maxWidth: "950px" }}>
        {faqs.map((item, index) => {
          const isOpen = activeIndex === index;
          return (
            <div
              key={index}
              className={`accordion ${isOpen ? "active" : ""}`}
              style={{
                background: "rgba(28, 28, 28, 0.85)",
                border: "1px solid rgba(255, 255, 255, 0.12)",
                borderRadius: "18px",
                margin: "14px auto",
                overflow: "hidden",
                transition: "all 0.3s ease"
              }}
            >
              <div
                className="accordion-header"
                onClick={() => toggleAccordion(index)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                  padding: "16px 20px",
                  cursor: "pointer",
                  background: "transparent",
                  borderRadius: "18px"
                }}
              >
                <h3 
                  style={{ 
                    margin: 0, 
                    color: "#ffffff", 
                    fontSize: "16px", 
                    fontWeight: "600",
                    lineHeight: "1.4"
                  }}
                >
                  {item.question}
                </h3>
                <div 
                  className="caret-box"
                  style={{
                    width: "36px",
                    height: "36px",
                    minWidth: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "12px",
                    background: "#f1833b",
                    color: "#000000"
                  }}
                >
                  <FaChevronDown
                    className={`caret ${isOpen ? "rotate" : ""}`}
                    style={{
                      transition: "transform 0.25s ease",
                      color: "#000000",
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
                    }}
                  />
                </div>
              </div>
              <div 
                className="accordion-content"
                style={{
                  maxHeight: isOpen ? "1000px" : "0px",
                  opacity: isOpen ? 1 : 0,
                  padding: isOpen ? "12px 20px 20px 20px" : "0px 20px",
                  overflow: "hidden",
                  transition: "all 0.35s ease",
                  background: "rgba(18, 18, 18, 0.6)",
                  borderTop: isOpen ? "1px solid rgba(255, 255, 255, 0.08)" : "none"
                }}
              >
                <p style={{ margin: 0, color: "rgba(255, 255, 255, 0.88)", lineHeight: "1.65", fontSize: "15px" }}>
                  {item.answer}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
